<template>
   <v-dialog  width="800px" :value="show" @input="$emit('close', $event)">
    <v-card height="535px">
      <v-card-text class="h-100 pb-0">
        <v-layout column h-100>
          <v-flex md1 mb-2>
            <v-layout row wrap>
              <filters-bar
                title="Canales"
                title-class="headline"
                :hasDateType="true"
                title-box-size="md3"
                date-box-size="md4"
                :filtersButton="false"
                @search="search"
                :filters="filters">
              </filters-bar>
            </v-layout>
          </v-flex>
          <v-flex >
            <vue-perfect-scrollbar>
              <v-container id="scrollBar" fluid grid-list-md pr-3>
                <v-layout row wrap>
                  <v-flex :mt-4="i > 1" class="text-xs-center" v-for="(pie, i) in data" :key="`channel-pie-${i}`" md6>
                    <v-layout row wrap>
                      <v-flex md2 offset-md4>
                        <v-icon class="k-orange-linear-text">
                          {{channels.find( x => x.id === pie.channel_id).icon }}
                        </v-icon>
                      </v-flex>
                      <v-flex text-xs-left>
                        <span class="subheading" >
                          {{channels.find( x => x.id === pie.channel_id).text }}
                        </span>
                      </v-flex>
                    </v-layout>
                    <v-layout row wrap>
                      <v-flex xs12>
                        <donnut :data="pie.data"></donnut>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-container>
            </vue-perfect-scrollbar>
          </v-flex>
          <v-flex>
            <v-layout class="h-100 ma-0" justify-end align-end>
              <v-btn flat  @click="$emit('close', false)">Cerrar</v-btn>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
<script>
import moment from 'moment';
import VuePerfectScrollbar from 'vue-perfect-scrollbar';
import FiltersBar from '@/components/global/FiltersBar';
import ChannelMixins from '@/mixins/channelsV2';
import Donnut from './Donnut';

export default {
  mixins: [ChannelMixins],
  props: {
    filters: {
      type: Object,
      default: () => {},
    },
    show: {
      type: Boolean,
      default: false,
    },
    data: {
      type: Array,
      default: [],
    },
  },
  components: {
    Donnut,
    FiltersBar,
    VuePerfectScrollbar,
  },
  data() {
    return {
      cancelToken: this.axios.CancelToken.source(),
    };
  },
  methods: {
    toHuman(time) {
      return moment.duration(time, 'seconds').humanize();
    },
    cancelSearch() {
      this.cancelToken.cancel('');
      this.cancelToken = this.axios.CancelToken.source();
    },
    search() {
      this.$emit('search');
    },
  },
  watch: {
    dialog(value) {
      if (value) {
        this.search();
      } else {
        this.cancelSearch();
      }
    },
  },
};
</script>
<style scoped>
.user-status {
  font-size: 16px;
  position: absolute;
  left: 2.5vw;
  top: 0;
}
.p-relative {
  position: relative;
}
.name-span, .email-span {
  display: block;
  line-height: 1;
}
.name-span {
  font-size: 20px;
  margin: 0;
  padding: 0;
  font-weight: 300;
}
.email-span {
  font-size: 10px;
  font-weight: 300;
}
.custom-caption {
  font-size: 9px;
  font-weight: 200;
  display: block;
  line-height: 1;
}
.custom-card {
  border: 1px solid #c7c4c4;
  box-shadow: 0px 0px 15px -2px #9e9e9e;
}
#scrollBar {
  height: 371px;
}
</style>



// WEBPACK FOOTER //
// src/components/chat_center_v2/dashboard/Distributions/ChannelsModal.vue